import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNewMobileLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 6.66667C0 2.98478 2.98477 0 6.66667 0H136C138.209 0 140 1.79086 140 4V133.333C140 137.015 137.015 140 133.333 140C59.6954 140 0 80.3046 0 6.66667Z",
		fill: "#105ED5"
	})
});
export { SvgNewMobileLogo as ReactComponent };
